import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import NfoFunds from "./nfoFunds";
import NfoTransact from "./NfoTransaction";

export default class NfoRouter extends Component {
  render() {
    const { history, location } = this.props;
    return (
      <Switch location={location} history={history}>
        <Route path={`/nfo-funds/nfo-transact`} component={NfoTransact} exact />
        <Route path={`/nfo-funds`} component={NfoFunds} exact />
      </Switch>
    );
  }
}
